import { Fraction } from 'bi-fraction';
import { create } from 'zustand';

type Step = 'BasicInfo' | 'ExtraInfo' | 'Purchase';
const steps: Step[] = ['BasicInfo', 'ExtraInfo', 'Purchase'];

interface UseCreateAgentModal {
  isOpen: boolean;
  buyAmount: Fraction;
  step: Step;
  stepIndex: number;
  closeModal: () => void;
  openModal: () => void;
  setBuyAmount: (amount: Fraction) => void;
  setStep: (step: Step) => void;
  setNextStep: () => void;
  setPrevStep: () => void;
}

export const useCreateAgentModal = create<UseCreateAgentModal>((set, get) => ({
  isOpen: false,
  buyAmount: Fraction.ZERO,
  step: 'BasicInfo' as const,
  stepIndex: 0,
  closeModal: () => {
    set({ isOpen: false });
  },
  openModal: () =>
    set({
      isOpen: true,
      step: 'BasicInfo',
      buyAmount: Fraction.ZERO,
      stepIndex: 0,
    }),
  setBuyAmount: (amount) => set({ buyAmount: amount }),
  setStep: (step) => {
    set({ step, stepIndex: steps.indexOf(step) });
  },
  setNextStep: () => {
    const currentStep = get().step;
    const currentIndex = get().stepIndex;
    const nextStep =
      currentStep === 'Purchase'
        ? 'Purchase'
        : steps[(currentIndex + 1) % steps.length];
    set({ step: nextStep, stepIndex: steps.indexOf(nextStep) });
  },
  setPrevStep: () => {
    const currentStep = get().step;
    const currentIndex = get().stepIndex;
    const prevStepIndex =
      currentStep === 'BasicInfo'
        ? 0
        : (currentIndex - 1 + steps.length) % steps.length;
    set({ step: steps[prevStepIndex], stepIndex: prevStepIndex });
  },
}));
